import { AgmCoreModule } from '@agm/core';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
// import { LanguageSelectorComponent } from '../../components/language-selector/language-selector.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
//import { StarRatingModule } from "ionic4-star-rating";
import { AuthComponent } from 'src/app/components/auth/auth.component';
import { FormPatchComponent } from 'src/app/components/form/form-patch/form-patch.component';
import { ListAutocompleteComponent } from 'src/app/components/list-autocomplete/list-autocomplete.component';
import { NftVerifyComponent } from 'src/app/components/nft/nft-verify/nft-verify.component';
import { SmartlabelSelectorComponent } from 'src/app/components/smartlabel-selector/smartlabel-selector.component';
import { environment } from '../../../environments/environment';
import { AlertBannerComponent } from '../../components/alert-banner/alert-banner.component';
import { BadgeSegmentComponent } from '../../components/badge-segment/badge-segment.component';
import { ButtonSegmentsComponent } from '../../components/button-segments/button-segments.component';
import { ButtonComponent } from "../../components/button/button.component";
import { CardComponent } from '../../components/card/card.component';
import { CarouselComponent } from '../../components/carousel/carousel.component';
import { ConditionalComponent } from '../../components/conditional/conditional.component';
import { ContentControlComponent } from '../../components/content-control/content-control.component';
import { FooterLinksComponent } from '../../components/footer-links/footer-links.component';
import { FormCheckboxComponent } from '../../components/form/form-checkbox/form-checkbox.component';
import { FormDatepickerComponent } from '../../components/form/form-datepicker/form-datepicker.component';
import { FormInputComponent } from '../../components/form/form-input/form-input.component';
import { FormRadioboxComponent } from '../../components/form/form-radiobox/form-radiobox.component';
import { FormRatingComponent } from "../../components/form/form-rating/form-rating.component";
import { FormSelectComponent } from '../../components/form/form-select/form-select.component';
import { FormComponent } from '../../components/form/form.component';
import { GridComponent } from '../../components/grid/grid.component';
import { HeadingComponent } from '../../components/heading/heading.component';
import { HrComponent } from '../../components/hr/hr.component';
import { ImageComponent } from '../../components/image/image.component';
import { JumbotronComponent } from '../../components/jumbotron/jumbotron.component';
import { LinkComponent } from '../../components/link/link.component';
import { ListItemComponent } from '../../components/list/list-item/list-item.component';
import { ListComponent } from '../../components/list/list.component';
import { MapsComponent } from '../../components/maps/maps.component';
import { ProductHeaderComponent } from '../../components/product-header/product-header.component';
import { RichTextComponent } from '../../components/rich-text/rich-text.component';
import { RowComponent } from '../../components/row/row.component';
import { SectionComponent } from '../../components/section/section.component';
import { SmartLabelBeverageComponent } from '../../components/smart-label/smart-label-beverage/smart-label-beverage.component';
import { SmartLabelFoodComponent } from '../../components/smart-label/smart-label-food/smart-label-food.component';
import { SmartLabelNonFoodComponent } from '../../components/smart-label/smart-label-non-food/smart-label-non-food.component';
import { SmartLabelOtcDrugComponent } from '../../components/smart-label/smart-label-otc-drug/smart-label-otc-drug.component';
import { SmartLabelSupplementComponent } from '../../components/smart-label/smart-label-supplement/smart-label-supplement.component';
import { SmartLabelComponent } from '../../components/smart-label/smart-label.component';
import { SocialComponent } from '../../components/social/social.component';
import { TabItemComponent } from '../../components/tabs/tab-item/tab-item.component';
import { TabsComponent } from '../../components/tabs/tabs.component';
import { VideoComponent } from '../../components/video/video.component';
import { SharedModule } from '../shared/shared.module';
import { MainRoutingModule } from './main-routing.module';
import { MainComponent } from './main.component';
import { SignInComponent } from '../../components/sign-in/sign-in.component';
import { RedirectComponent } from 'src/app/redirect/redirect.component';
import { VeVerifyComponent } from 'src/app/ve-verify/ve-verify.component';
import { RecaptchaModule } from 'ng-recaptcha';







//library.add(fas, far);

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    MainRoutingModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    RecaptchaModule,
    AgmCoreModule.forRoot({
      apiKey: environment.googleApiKey
    }),
    // StarRatingModule COMMENTED FOR UPGRADE
  ],
  declarations: [
    MainComponent,
    SmartLabelComponent,
    SmartLabelFoodComponent,
    SmartLabelBeverageComponent,
    ProductHeaderComponent,
    SmartLabelNonFoodComponent,
    ContentControlComponent,
    CarouselComponent,
    JumbotronComponent,
    AlertBannerComponent,
    RowComponent,
    CardComponent,
    TabsComponent,
    GridComponent,
    ListComponent,
    ListItemComponent,
    RichTextComponent,
    MapsComponent,
    ButtonSegmentsComponent,
    FooterLinksComponent,
    SocialComponent,
    TabItemComponent,
    HeadingComponent,
    SmartLabelOtcDrugComponent,
    SectionComponent,
    ImageComponent,
    HrComponent,
    VideoComponent,
    LinkComponent,
    FormComponent,
    FormInputComponent,
    FormSelectComponent,
    FormCheckboxComponent,
    FormRadioboxComponent,
    ConditionalComponent,
    FormDatepickerComponent,
    SmartlabelSelectorComponent,
    BadgeSegmentComponent,
    FormRatingComponent,
    SmartLabelSupplementComponent,
    ButtonComponent,
    AuthComponent,
    FormPatchComponent,
    ListAutocompleteComponent,
    NftVerifyComponent,
    SignInComponent,
    RedirectComponent,
    VeVerifyComponent
  ]
})
export class MainPageModule { }
